import {Injectable} from '@angular/core';
import {AuthService} from '@auth0/auth0-angular';

@Injectable({providedIn: 'root'})
export class LogoutService {

    constructor(private authService: AuthService) {
    }

    logout(): void {
        localStorage.setItem('authUser', 'false');
        localStorage.setItem('idUser', '');
        localStorage.setItem('infoUser', '');
        localStorage.setItem('dataList', '');
        localStorage.setItem('dataAllLists', '');
        localStorage.setItem('impersonating', '');
        localStorage.setItem('impersonatedOrganizer', '');
        localStorage.setItem('impersonatedOrganizerName', '');
        localStorage.setItem('originalUserEmail', '');
        localStorage.setItem('isAdmin', '');
        localStorage.setItem('canImpersonate', '');
        localStorage.setItem('impersonateRole', '');

        this.authService.logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    }
}
